module.exports = {"start":"start","restart":"restart","testing":"Testing #{test}","download":"Download","upload":"Upload","latency":"Latency","jitter":"Jitter","poweredBy":"Powered by","mbps":"Mbps","kbps":"Kbps","ms":"ms","s":"s","internetPerformanceTest":"Internet performance test","yourIp":"Your IP:","testServerLocation":"Test server location:","referenceNumber":"Reference number:","startTest":"Start test","initialising":"Initialising #{test}","initiateFail":"There has been a problem, please try again"}


//////////////////
// WEBPACK FOOTER
// ./src/js/i18n/en-GB.json
// module id = 204
// module chunks = 0